export default event => event.key || event.keyCode;